import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getBestSellersAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_BEST_SELLERS,
    payload: paramObj,
    meta: {
        type: 'api',
        url: baseUrl + '/best_sellers',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            num_of_products: paramObj.numOfProducts,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond
        },
        options: {
            method: 'GET'
        }
    }
})